"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var flatMap_1 = require("./flatMap");
function listMap(project) {
    return operators_1.map(function (list) { return list.map(project); });
}
exports.listMap = listMap;
function flatListMap(project) {
    return flatMap_1.flatMap(function (list) { return rxjs_1.zip.apply(void 0, list.map(project)); });
}
exports.flatListMap = flatListMap;
function listFlatMap(project) {
    return operators_1.map(function (list) { return list.flatMap(project); });
}
exports.listFlatMap = listFlatMap;
function flatListFlatMap(project) {
    return flatMap_1.flatMap(function (list) { return rxjs_1.zip.apply(void 0, list.flatMap(function (value) { return project(value); })).pipe(operators_1.map(function (list) { return list.flatMap(function (arrayMember) { return arrayMember; }); })); });
}
exports.flatListFlatMap = flatListFlatMap;
